import React from 'react';

import {ToolsRibbonComponent} from 'src/components/selection-toolbar/tools-ribbon-component';

import {Body, Cell, Row, Table} from '@pb/kit-component-table';

import {infoMessage} from './../access-management.module.styl';
import {AccessManagementTableHeader} from './access-management-table-header';

import type {Role} from '../../../openapi/admin/models/Role';
import type {Tool} from '../../../openapi/admin/models/Tool';
import type {Vendor} from '../../../openapi/admin/models/Vendor';


type Props = {
    hasActiveFilter: boolean,
    selectedCount: number,
    onClearFilters?: () => void,
    emailSortDir: 'ASC' | 'DESC',
    onEmailSortChange: (d: 'ASC' | 'DESC') => void,
    roleId?: string,
    onRoleIdChange: (id?: string) => void,
    vendorId?: string,
    onVendorIdChange: (id?: string) => void,
    toolId?: string,
    onToolIdChange: (id?: string) => void,
    roles: Role[],
    vendors: Vendor[],
    tools: Tool[],
};

export const NoResults: React.FC<Props> = ({
    hasActiveFilter,
    selectedCount,
    emailSortDir,
    onEmailSortChange,
    roleId,
    onRoleIdChange,
    vendorId,
    onVendorIdChange,
    toolId,
    onToolIdChange,
    roles,
    vendors,
    tools,
}) => (
    <>
        <ToolsRibbonComponent
            totalCount={0}
            pageIds={[]}
            selectedCount={selectedCount}
            pageSelectedCount={0}
            allSelected={false}
            onSelectAll={() => {}}
            onSelectPage={() => {}}
            onClear={() => {}}
        />
        <Table borderedColumns={true}>
            <AccessManagementTableHeader
                totalCount={0}
                allSelected={false}
                onSelectAll={() => {}}
                onClearAll={() => {}}
                emailSortDir={emailSortDir}
                onEmailSortChange={onEmailSortChange}
                roleId={roleId}
                onRoleIdChange={onRoleIdChange}
                vendorId={vendorId}
                onVendorIdChange={onVendorIdChange}
                toolId={toolId}
                onToolIdChange={onToolIdChange}
                roles={roles}
                vendors={vendors}
                tools={tools}
            />
            <Body>
                <Row>
                    <Cell colSpan={8}>
                        <div style={{padding: '32px', textAlign: 'center'}}>
                            <div style={{fontWeight: 600, marginBottom: 4}}>No users found</div>
                            {hasActiveFilter ?
                                    <div className={infoMessage}>Try adjusting the search criteria.</div> :
                                null}
                        </div>
                    </Cell>
                </Row>
            </Body>
        </Table>
    </>
);
